export default __webpack_public_path__ + "static/media/historybg.ca207c32.jpg";